module.exports = __webpack_public_path__ + "img/grd.8e690a5a.svg";